// Formats "YYYY-MM-DD" to "DD/MM/YYYY"
export const formatDateWithSlash = (date) => {
    return new Intl.DateTimeFormat('en-GB').format(new Date(date));
};
